import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';

@Component({
    selector: 'fade-slider-slide',
    styleUrl: './fade-slider-slide.scss',
    template: '<ng-content />',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FadeSliderSlideComponent {
    private _current: boolean = false;

    get current() {
        return this._current;
    }
    set current(val: boolean) {
        this._current = val;
        val
            ? this.renderer2.addClass(this.elementRef.nativeElement, 'current')
            : this.renderer2.removeClass(this.elementRef.nativeElement, 'current');
    }

    constructor(
        private renderer2: Renderer2,
        private elementRef: ElementRef
    ) {}
}
